import DtoMaterielAssignment from './DtoMaterielAssignment'
import EquipmentDto from '../../../materiel/components/equipment/dto/EquipmentDto'

export default class DtoStationEquipmentAssignment extends DtoMaterielAssignment {
    constructor(obj) {
        super(obj)
        this.id = obj.idEquipmentSituation
        this.idEquipmentSituation = obj.idEquipmentSituation
        this.idEquipment = obj.idEquipment
        this.materielId = obj.idEquipment
        this.materiel = obj.materiel?.equipment && new EquipmentDto(obj.materiel.equipment)
    }
}
